import { useEffect, useState } from "react";
import CustomValuesHook from "../../../Hooks/customValuesHook";
import headings from "../../../constants/headings";
import GSPTable from "../../../shared/GSFTable";
import "../style.scss";
import { ErrorToast, InfoToast } from "../../../shared";
import { changeState } from "../../../api/requestAxios/getDetectedSensitiveWordLog";
import { DateToPersianNumber, ToPersianNumber } from "../../../functions";
import moment from "moment-jalaali";
import ModalContent from "./modalContent";
import { enToPersianChar } from "../../../functions/extensions/enToPersianChar";
import { Navigate, useNavigate } from "react-router";
import { Link } from "react-router-dom";

const ListActivity = ({
  data,
  loading,
  select,
  getLog,
  userId,
  setUserId,
  login,
  token,
}) => {
  const [states, setStates] = CustomValuesHook({
    status: "",
    item: {},
    description: "",
    show: false,
    showUserInfo: false,
    whereCondition: "",
  });

  const [loadingChangeStatus, setLoadingChangeStatus] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setStates({
      whereCondition: `Type=${select?.typeActivity} && State=${
        select?.statusCustomer
      } ${select?.customerId && "&& customerId=select?.customerId"}`,
    });
  }, [select]);

  const changeStatus = async (obj) => {
    setLoadingChangeStatus(true);
    try {
      const response = await changeState(obj);
      setLoadingChangeStatus(false);
      setStates({ show: false });
      getLog(states?.whereCondition);
    } catch (error) {
      ErrorToast(error);
      setLoadingChangeStatus(false);
    }
  };

  const setStatus = (e, typeStatus, _item) => {
    e.preventDefault();
    setStates({ status: typeStatus, item: _item, show: true });
  };

  const returnIgnore = (item) => {
    if (
      item.type === "IvrSetting" &&
      (item?.state === "New" || item?.state === "InvestigationPending")
    ) {
      return true;
    } else return false;
  };

  const returnInvestigationPending = (item) => {
    if (item.type === "IvrSetting" && item?.state === "New") return true;
    else return false;
  };

  const returnViewDiscription = (item) => {
    if (item.type === "IvrSetting" && item?.state === "InvestigationPending")
      return true;
    else return false;
  };

  const returnBlock = (item) => {
    if (
      (item.type === "IvrSetting" && item?.state === "New") ||
      item?.state === "InvestigationPending"
    )
      return true;
    else return false;
  };
  const returnUnBlock = (item) => {
    if (item.type === "IvrSetting" && item?.state === "Block") return true;
    else return false;
  };

  const blockUser = (e, item) => {
    if (!item?.customerIsSuspended && item?.customerUserIsActive) {
      setStatus(e, "block-status", item);
    } else {
      changeStatus({
        id: item?.id,
        state: "Block",
        description: "",
      });
    }
  };

  const unBlockUser = (e, item) => {
    if (item?.customerIsSuspended && item?.customerUserIsActive) {
      setStatus(e, "unblock-status", item);
    } else {
      changeStatus({
        id: item?.id,
        state: "Ignore",
        description: "",
      });
    }
  };

  const options = ({ item }) => {
    return (
      <div className="d-flex flex-row justify-content-center options-container">
        <span
          className="set-status-user initail-status"
          onClick={(e) => setStatus(e, "initail-status", item)}
        >
          {" "}
          مشاهده‌ی پیام آغازین
        </span>
        {returnInvestigationPending(item) && (
          <span
            className="set-status-user followup-status"
            onClick={(e) => setStatus(e, "followup-status", item)}
          >
            نیاز به پیگیری
          </span>
        )}
        {returnViewDiscription(item) && (
          <span
            className="set-status-user initail-status"
            onClick={(e) => setStatus(e, "view-discription", item)}
          >
            مشاهده‌ی توضیح همکار
          </span>
        )}

        {returnIgnore(item) && (
          <span
            className="set-status-user ignore-status"
            onClick={(e) => setStatus(e, "ignore-status", item)}
          >
            {" "}
            نادیده گرفتن
          </span>
        )}
        {returnBlock(item) && (
          <span
            className="set-status-user block-status"
            onClick={(e) => blockUser(e, item)}
          >
            مسدود کردن
          </span>
        )}
        {returnUnBlock(item) && (
          <span
            className="set-status-user block-status"
            onClick={(e) => unBlockUser(e, item)}
          >
            رفع مسدودی
          </span>
        )}
      </div>
    );
  };

  const dateComponent = ({ item }) => {
    return DateToPersianNumber(
      moment(item.date).locale("fa").format("jYYYY/jMM/jDD HH:MM:SS")
    );
  };

  const termsComponent = ({ item }) => {
    let tmp = item.terms.split("|*|");
    let str = "";
    tmp.forEach((_item) => {
      str = str + " " + _item + ",";
    });
    return str.substring(0, str.length - 1);
  };

  const typeComponent = ({ item }) => {
    return item.type === "IvrSetting" ? "کلمات حساس در سرویس گویا" : item?.type;
  };

  const lineNumberComponent = ({ item }) => {
    return (item.customerLineNumber = enToPersianChar(
      item.customerLineNumber?.replace("+98", "0")
    ));
  };

  const customerComponent = ({ item }) => {
    return (
      <a
        onClick={() => {
          setStates({ showUserInfo: true });
          setUserId(item?.customerId);
        }}
        className="link-user-info"
      >
        {item?.customerFullName}
      </a>
    );
  };

  const columns = [
    {
      title: "ردیف",
      property: "row",
      filterProperty: "null",
      hasSort: false,
      hasFilter: false,
      display: true,
    },
    {
      title: "نوع فعالیت",
      property: "type",
      filterProperty: null,
      hasSort: true,
      hasFilter: false,
      display: true,
      component: typeComponent,
    },
    {
      title: "شماره",
      property: "customerLineNumber",
      filterProperty: null,
      hasSort: true,
      hasFilter: true,
      display: true,
      component: lineNumberComponent,
    },
    {
      title: "مشترک",
      property: "customerFullName",
      filterProperty: null,
      hasSort: false,
      display: true,
      component: customerComponent,
    },
    {
      title: "ایمیل",
      property: "customerEmail",
      filterProperty: null,
      hasSort: false,
      display: true,
    },
    {
      title: "تاریخ آخرین تغییرات",
      property: "date",
      filterProperty: null,
      hasSort: false,
      display: true,
      component: dateComponent,
    },
    {
      title: "کلمات مشکوک",
      property: "terms",
      filterProperty: null,
      hasSort: false,
      display: true,
      component: termsComponent,
    },
    {
      title: "عملیات",
      filterProperty: null,
      hasSort: false,
      display: true,
      component: options,
    },
  ];

  return (
    <>
      {!states?.showUserInfo ? (
        <div className="sensitive-activity-list">
          {data?.data?.length > 0 ? (
            <GSPTable
              columns={columns}
              hasSorting={false}
              dataList={data}
              hasFiltering={false}
              isSearchByExternalBtn={false}
              loading={loading}
              enableScrolling={false}
              searchBtnText={"جستجو"}
              isStepScrolling={false}
              hasPaging={true}
            />
          ) : (
            <p className="no-data">
              با توجه به فیلتر ایجاد شده اطلاعات وجود ندارد.
            </p>
          )}
          {states?.status === "unblock-status" && (
            <ModalContent
              from="UnBlockUser"
              header={"رفع مسدود کردن کاربر"}
              setStates={setStates}
              states={states}
              changeStatus={changeStatus}
              loading={loading}
            />
          )}
          {states?.status === "block-status" && (
            <ModalContent
              from="BlockUser"
              header={"مسدود کردن کاربر"}
              setStates={setStates}
              states={states}
              changeStatus={changeStatus}
              loading={loading}
            />
          )}
          {states?.status === "initail-status" && (
            <ModalContent
              from="InitialMessageView"
              header={"پیام آغازین"}
              setStates={setStates}
              states={states}
              changeStatus={undefined}
              loading={undefined}
            />
          )}
          {states?.status === "followup-status" && (
            <ModalContent
              from="RequsetPendingReason"
              header={"درخواست انتظار برای پیگیری"}
              setStates={setStates}
              states={states}
              changeStatus={changeStatus}
              loading={loading}
            />
          )}

          {states?.status === "view-discription" && (
            <ModalContent
              from="InvestigationPending"
              header={"توضیح همکار"}
              setStates={setStates}
              states={states}
              changeStatus={changeStatus}
              loading={loading}
            />
          )}
          {states?.status === "ignore-status" && (
            <ModalContent
              from="Ignore"
              header={"نادیده گرفتن"}
              setStates={setStates}
              states={states}
              changeStatus={changeStatus}
              loading={loading}
            />
          )}
        </div>
      ) : (
        <Navigate to={"/user-info"} state={{ login: login, token: token }} />
      )}
    </>
  );
};
export default ListActivity;
